import { FeatureAccessRI } from '../rest-interfaces/feature-access-ri';
import { FeatureNameRI } from '../rest-interfaces/feature-name-ri';

export class FeatureAccessChecker {
  constructor(private featureAccess: FeatureAccessRI) {}

  hasAccess(featureName: FeatureNameRI): boolean {
    return this.featureAccess[featureName] === true;
  }
}
